<template>
  <div id="employment-info">
    <v-card class="card-shadow border-radius-xl mt-4">
      <v-card-title class="pb-0 d-flex align-center">
        <h6 class="mb-0 text-h6 text-typo font-weight-bold">僱用資料</h6>
        <v-spacer></v-spacer>
        <template v-if="canEditRole && !isCreateMode">
          <template v-if="!edit">
            <v-btn icon @click="startEdit" :ripple="false">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <!-- <v-btn icon @click="showHistory" :ripple="false">
              <v-icon>mdi-history</v-icon>
            </v-btn> -->
          </template>
          <template v-else>
            <v-btn icon class="mr-2" @click="cancelEdit" :ripple="false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-btn icon :loading="saving" @click="submit" :ripple="false">
              <v-icon color="red">mdi-content-save</v-icon>
            </v-btn>
          </template>
        </template>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="3">
            <v-list-item class="px-0">
              <v-list-item-content>
                <v-list-item-subtitle class="text-sm text-body"
                  >到職日期</v-list-item-subtitle
                >
                <v-list-item-title v-if="!edit" class="text-body-1 text-typo">{{
                  formatDate(profileData.expected_sign_date)
                }}</v-list-item-title>
                <v-menu
                  v-else
                  v-model="signMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="form.expected_sign_date"
                      v-bind="attrs"
                      v-on="on"
                      dense
                      hide-details="auto"
                      readonly
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    color="blue"
                    v-model="form.expected_sign_date"
                    @input="signMenu = false"
                    locale="zh-TW"
                  ></v-date-picker>
                </v-menu>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col cols="12" md="3">
            <v-list-item class="px-0">
              <v-list-item-content>
                <v-list-item-subtitle class="text-sm text-body"
                  >離職日期</v-list-item-subtitle
                >
                <v-list-item-title v-if="!edit" class="text-body-1 text-typo">{{
                  profileData.expected_resign_date
                    ? formatDate(profileData.expected_resign_date)
                    : "未設定"
                }}</v-list-item-title>
                <v-menu
                  v-else
                  v-model="resignMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="form.expected_resign_date"
                      v-bind="attrs"
                      v-on="on"
                      dense
                      hide-details="auto"
                      clearable
                      @click:clear="clearResignDate"
                      readonly
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    color="blue"
                    v-model="form.expected_resign_date"
                    @input="resignMenu = false"
                    locale="zh-TW"
                  ></v-date-picker>
                </v-menu>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <!-- <v-col cols="12" md="3">
            <v-list-item class="px-0">
              <v-list-item-content>
                <v-list-item-subtitle class="text-sm text-body"
                  >備註</v-list-item-subtitle
                >
                <v-list-item-title v-if="!edit" class="text-body-1 text-typo">{{
                  profileData.note || "未設定"
                }}</v-list-item-title>
                <v-text-field
                  v-else
                  v-model="form.note"
                  dense
                  hide-details="auto"
                ></v-text-field>
              </v-list-item-content>
            </v-list-item>
          </v-col> -->
          <v-col cols="12" md="6">
            <v-list-item class="px-0">
              <v-list-item-content>
                <v-list-item-subtitle class="text-sm text-body"
                  >合約工作型態</v-list-item-subtitle
                >
                <v-list-item-title v-if="!edit" class="text-body-1 text-typo">{{
                  getContractWorkType(profileData.contract_work_type)
                }}</v-list-item-title>
                <v-select
                  v-else
                  v-model="form.contract_work_type"
                  :items="contractWorkTypeItems"
                  dense
                  hide-details="auto"
                ></v-select>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col cols="12" md="3">
            <v-list-item class="px-0">
              <v-list-item-content>
                <v-list-item-subtitle class="text-sm text-body"
                  >僱用類別</v-list-item-subtitle
                >
                <v-list-item-title v-if="!edit" class="text-body-1 text-typo">{{
                  getJoinType(profileData.join_type)
                }}</v-list-item-title>
                <v-select
                  v-else
                  v-model="form.join_type"
                  :items="employmentTypeItems"
                  dense
                  hide-details="auto"
                ></v-select>
              </v-list-item-content>
            </v-list-item>
          </v-col>

          <v-col cols="12" md="3">
            <v-list-item class="px-0">
              <v-list-item-content>
                <v-list-item-subtitle class="text-sm text-body"
                  >合約薪水類別</v-list-item-subtitle
                >
                <v-list-item-title v-if="!edit" class="text-body-1 text-typo">{{
                  getSalaryType(profileData.contract_salary_type)
                }}</v-list-item-title>
                <v-select
                  v-else
                  v-model="form.contract_salary_type"
                  :items="salaryTypeItems"
                  dense
                  hide-details="auto"
                  @input="form.contract_salary_type = Number($event)"
                ></v-select>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col
            cols="12"
            md="2"
            v-if="form.join_type === 2 && form.contract_salary_type === 2"
          >
            <v-list-item class="px-0">
              <v-list-item-content>
                <v-list-item-subtitle class="text-sm text-body"
                  >時薪類型</v-list-item-subtitle
                >
                <v-tooltip
                  v-if="!edit"
                  bottom
                  :disabled="
                    !getHourlySalaryTypeHint(profileData.hourly_salary_type)
                  "
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-list-item-title
                      class="text-body-1 text-typo"
                      v-bind="attrs"
                      v-on="on"
                    >
                      {{ getHourlySalaryType(profileData.hourly_salary_type) }}
                    </v-list-item-title>
                  </template>
                  <span>{{
                    getHourlySalaryTypeHint(profileData.hourly_salary_type)
                  }}</span>
                </v-tooltip>
                <v-select
                  v-else
                  v-model="form.hourly_salary_type"
                  :items="hourlySalaryTypeItems"
                  dense
                  hide-details="auto"
                ></v-select>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <!-- 部分工時 -->
          <v-col
            cols="12"
            md="2"
            v-if="form.join_type === 2 && form.contract_salary_type === 1"
          >
            <v-list-item class="px-0">
              <v-list-item-content>
                <v-list-item-subtitle class="text-sm text-body"
                  >每日工時(部份工時-月薪制)</v-list-item-subtitle
                >
                <v-list-item-title v-if="!edit" class="text-body-1 text-typo">{{
                  profileData.part_time_monthly_hours || "未設定"
                }}</v-list-item-title>
                <v-text-field
                  v-else
                  v-model.number="form.part_time_monthly_hours"
                  type="number"
                  step="0.01"
                  dense
                  hide-details="auto"
                ></v-text-field>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col
            cols="6"
            md="2"
            v-if="form.join_type === 2 && form.contract_salary_type === 2"
          >
            <v-list-item class="px-0">
              <v-list-item-content>
                <v-list-item-subtitle class="text-sm text-body"
                  >部份工時-時薪</v-list-item-subtitle
                >
                <v-list-item-title v-if="!edit" class="text-body-1 text-typo">{{
                  profileData.part_time_hourly_wage || "未設定"
                }}</v-list-item-title>
                <v-text-field
                  v-else
                  v-model.number="form.part_time_hourly_wage"
                  type="number"
                  dense
                  hide-details="auto"
                ></v-text-field>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col cols="6" md="2" v-if="isHourlyContractHoursRequired">
            <v-list-item class="px-0">
              <v-list-item-content>
                <v-list-item-subtitle class="text-sm text-body"
                  >部份工時-每日約定工時</v-list-item-subtitle
                >
                <v-list-item-title v-if="!edit" class="text-body-1 text-typo">{{
                  profileData.part_time_hourly_contract_hours || "未設定"
                }}</v-list-item-title>
                <v-text-field
                  v-else
                  v-model.number="form.part_time_hourly_contract_hours"
                  type="number"
                  dense
                  hide-details="auto"
                  :error="isHourlyContractHoursMissing"
                  :error-messages="
                    isHourlyContractHoursMissing
                      ? ['請輸入每日約定工時（需大於 0）']
                      : []
                  "
                ></v-text-field>
              </v-list-item-content>
            </v-list-item>
          </v-col>

          <v-col cols="12" md="2" v-if="showHourlyFixedClockSetting">
            <v-card outlined class="pa-3" ref="hourlyClockCard">
              <div class="text-sm text-body mb-2">約定上下班時間</div>
              <div class="text-body-1 text-typo d-flex flex-wrap align-center">
                <span class="mr-4">上班：{{ hourlyClockInDisplay }}</span>
                <span>下班：{{ hourlyClockOutDisplay }}</span>
                <v-progress-circular
                  v-if="clockSettingLoading"
                  indeterminate
                  size="20"
                  width="2"
                  color="primary"
                  class="ml-3"
                />
              </div>
              <v-btn
                v-if="edit"
                class="
                  mt-3
                  font-weight-bold
                  text-capitalize
                  ms-auto
                  btn-default
                  bg-gradient-default
                  py-3
                  px-6
                  ms-3
                "
                small
                color="primary"
                :disabled="
                  !canEditRole || clockSettingLoading || !canEditClockSetting
                "
                @click="openClockSettingDialog"
              >
                設定時間
              </v-btn>
              <div
                v-if="isHourlyFixedClockMissing"
                class="text-caption text-danger mt-3"
              >
                約定時段必須設定上下班時間，請點「設定時間」完成後再儲存。
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-model="clockSettingDialogVisible" max-width="480px">
      <v-card>
        <v-card-title class="text-h6">設定上下班時間</v-card-title>
        <v-card-text>
          <v-alert v-if="clockSettingError" type="error" dense class="mb-4">
            {{ clockSettingError }}
          </v-alert>
          <v-alert
            v-else-if="clockSettingSuccess"
            type="success"
            dense
            class="mb-4"
          >
            {{ clockSettingSuccess }}
          </v-alert>
          <v-form>
            <v-menu
              v-model="clockSettingMenus.clockIn"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="formatClockDisplay(clockSettingForm.clock_in_time)"
                  label="上班時間"
                  outlined
                  dense
                  readonly
                  :disabled="clockSettingSaving"
                  v-bind="attrs"
                  v-on="on"
                  @click="
                    !clockSettingSaving && (clockSettingMenus.clockIn = true)
                  "
                ></v-text-field>
              </template>
              <v-time-picker
                v-model="clockSettingForm.clock_in_time"
                format="24hr"
                full-width
                color="blue"
                scrollable
                :disabled="clockSettingSaving"
                @change="clockSettingMenus.clockIn = false"
              ></v-time-picker>
            </v-menu>
            <v-menu
              v-model="clockSettingMenus.clockOut"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="formatClockDisplay(clockSettingForm.clock_out_time)"
                  label="下班時間"
                  outlined
                  dense
                  readonly
                  :disabled="clockSettingSaving"
                  v-bind="attrs"
                  v-on="on"
                  @click="
                    !clockSettingSaving && (clockSettingMenus.clockOut = true)
                  "
                ></v-text-field>
              </template>
              <v-time-picker
                v-model="clockSettingForm.clock_out_time"
                format="24hr"
                full-width
                color="blue"
                scrollable
                :disabled="clockSettingSaving"
                @change="clockSettingMenus.clockOut = false"
              ></v-time-picker>
            </v-menu>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeClockSettingDialog">取消</v-btn>
          <v-btn
            class="
              font-weight-bold
              text-capitalize
              ms-auto
              btn-default
              bg-gradient-default
              py-3
              px-6
              ms-3
            "
            @click="saveClockSetting"
          >
            儲存
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  EMPLOYMENT_TYPE,
  CONTRACT_WORK_TYPE,
  CONTRACT_TYPE,
  SALARY_TYPE,
  HOURLY_SALARY_TYPE,
} from "@/constants";
export default {
  name: "EmploymentInfoWidget",
  props: {
    profileData: {
      type: Object,
      default: () => ({}),
    },
    isCreateMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      edit: this.isCreateMode,
      saving: false,
      signMenu: false,
      resignMenu: false,
      isInitialized: false,
      form: {
        join_type: 1,
        contract_work_type: 1,
        contract_salary_type: 1,
        hourly_salary_type: null,
        part_time_monthly_hours: null,
        part_time_hourly_wage: null,
        part_time_hourly_contract_hours: null,
        work_type: 0,
        expected_sign_date: "",
        expected_resign_date: "",
        blood_type: "",
        native_place: "",
        english_name: "",
        insured_unit: "",
        note: "",
      },
      clockSettingDialogVisible: false,
      clockSettingLoading: false,
      clockSettingSaving: false,
      clockSettingError: "",
      clockSettingSuccess: "",
      clockSettingForm: {
        clock_in_time: "",
        clock_out_time: "",
      },
      clockSettingInfo: {
        clock_in_time: null,
        clock_out_time: null,
      },
      clockSettingMenus: {
        clockIn: false,
        clockOut: false,
      },
      employmentTypeItems: Object.keys(EMPLOYMENT_TYPE).map((k) => ({
        value: Number(k),
        text: EMPLOYMENT_TYPE[k],
      })),
      contractWorkTypeItems: Object.keys(CONTRACT_WORK_TYPE).map((k) => ({
        value: Number(k),
        text: CONTRACT_WORK_TYPE[k],
      })),
      salaryTypeItems: Object.keys(SALARY_TYPE)
        .filter((k) => k !== "0")
        .map((k) => ({ value: Number(k), text: SALARY_TYPE[k] })),
      hourlySalaryTypeItems: Object.keys(HOURLY_SALARY_TYPE).map((k) => ({
        value: Number(k),
        text: HOURLY_SALARY_TYPE[k],
      })),
      hourlySalaryTypeHints: {
        1: "排班(班表)：請至排班資訊上傳時薪班表",
        2: "約定時段：每日固定時段，例如：下午 2:00 ~ 6:00",
        3: "約定時數：每日做幾小時",
      },
    };
  },
  computed: {
    ...mapGetters({
      canEditRole: "user/canEditRole",
    }),
    calculatedDuration() {
      const startStr = this.edit
        ? this.form.expected_sign_date
        : this.profileData.expected_sign_date;
      if (!startStr) return "未設定";

      const startDate = new Date(startStr);
      const today = new Date();

      if (startDate > today) return "未開始";

      let years = today.getFullYear() - startDate.getFullYear();
      let months = today.getMonth() - startDate.getMonth();
      let days = today.getDate() - startDate.getDate();

      if (days < 0) {
        months -= 1;
        const lastMonth = new Date(today.getFullYear(), today.getMonth(), 0);
        days += lastMonth.getDate();
      }
      if (months < 0) {
        years -= 1;
        months += 12;
      }

      let result = "";
      if (years > 0) result += `${years} 年 `;
      if (months > 0) result += `${months} 月 `;
      if (days > 0 || result === "") result += `${days} 日`;

      return result.trim();
    },
    hourlyFixedClockRequired() {
      return (
        this.form.join_type === 2 &&
        this.form.contract_salary_type === 2 &&
        this.form.hourly_salary_type === 2
      );
    },
    showHourlyFixedClockSetting() {
      return (
        this.hourlyFixedClockRequired &&
        !this.isCreateMode &&
        this.canLoadClockSetting
      );
    },
    isHourlyFixedClockMissing() {
      if (!this.hourlyFixedClockRequired) return false;
      return (
        !this.clockSettingInfo.clock_in_time ||
        !this.clockSettingInfo.clock_out_time
      );
    },
    isHourlyContractHoursRequired() {
      return (
        this.form.join_type === 2 &&
        this.form.contract_salary_type === 2 &&
        this.form.hourly_salary_type === 3
      );
    },
    isHourlyContractHoursMissing() {
      if (!this.isHourlyContractHoursRequired) return false;
      const value = Number(this.form.part_time_hourly_contract_hours);
      return !Number.isFinite(value) || value <= 0;
    },
    canLoadClockSetting() {
      return Boolean(this.clockSettingCompanyId && this.clockSettingUserId);
    },
    canEditClockSetting() {
      return this.canEditRole && this.canLoadClockSetting && !this.isCreateMode;
    },
    hourlyClockInDisplay() {
      return this.formatClockDisplay(this.clockSettingInfo.clock_in_time);
    },
    hourlyClockOutDisplay() {
      return this.formatClockDisplay(this.clockSettingInfo.clock_out_time);
    },
    clockSettingUserId() {
      return (
        this.profileData?.user_id ||
        this.profileData?.userId ||
        this.profileData?.user?.id ||
        null
      );
    },
    clockSettingCompanyId() {
      return (
        this.profileData?.company_id ||
        this.profileData?.companyId ||
        this.profileData?.company?.id ||
        null
      );
    },
  },
  watch: {
    profileData: {
      handler() {
        this.resetForm();
      },
      immediate: true,
      deep: true,
    },
    form: {
      handler(newVal) {
        // In create mode, emit changes immediately (but skip initial load)
        if (this.isCreateMode && this.isInitialized) {
          this.$emit("save", newVal, () => {});
        }
      },
      deep: true,
    },
  },
  methods: {
    clearResignDate() {
      this.form.expected_resign_date = null;
      this.resignMenu = false;
    },
    showHistory() {
      this.$emit("show-history");
    },
    formatDate(dateString) {
      if (!dateString) return "未設定";
      const date = new Date(dateString);
      return date.toLocaleDateString();
    },
    getJoinType(type) {
      return EMPLOYMENT_TYPE[type] || `未設定`;
    },
    getContractWorkType(type) {
      if (!type && type !== 0) return "未設定";
      return CONTRACT_WORK_TYPE[type] || `未設定`;
    },
    getSalaryType(type) {
      if (!type && type !== 0) return "未設定";
      return SALARY_TYPE[type] || `Type ${type}`;
    },
    getHourlySalaryType(type) {
      if (!type) return "未設定";
      return HOURLY_SALARY_TYPE[type] || "未設定";
    },
    getHourlySalaryTypeHint(type) {
      return this.hourlySalaryTypeHints[type] || "";
    },
    getContractType(type) {
      return CONTRACT_TYPE[type] || `未設定`;
    },
    resetForm() {
      this.form = {
        join_type: this.profileData.join_type ?? 1,
        contract_work_type: this.profileData.contract_work_type ?? 1,
        contract_salary_type: this.profileData.contract_salary_type ?? 1,
        hourly_salary_type: this.profileData.hourly_salary_type ?? null,
        part_time_monthly_hours:
          this.profileData.part_time_monthly_hours ?? null,
        part_time_hourly_wage: this.profileData.part_time_hourly_wage ?? null,
        part_time_hourly_contract_hours:
          this.profileData.part_time_hourly_contract_hours ?? null,
        work_type: this.profileData.work_type ?? 0,
        expected_sign_date: this.profileData.expected_sign_date || "",
        expected_resign_date: this.profileData.expected_resign_date || null,
        blood_type: this.profileData.blood_type || "",
        native_place: this.profileData.native_place || "",
        english_name: this.profileData.english_name || "",
        insured_unit: this.profileData.insured_unit || "",
        note: this.profileData.note || "",
      };
      const fixedTimes = this.parseHourlyFixedTimes(
        this.profileData.hourly_fixed_clock_times
      );
      this.clockSettingInfo = {
        clock_in_time: fixedTimes.clock_in_time || null,
        clock_out_time: fixedTimes.clock_out_time || null,
      };
      // Mark as initialized after first reset
      this.$nextTick(() => {
        this.isInitialized = true;
      });
    },
    formatClockDisplay(val) {
      if (!val) return "未設定";
      return val.slice(0, 5);
    },
    parseHourlyFixedTimes(raw) {
      if (!raw) return {};
      if (typeof raw === "object") return raw;
      if (typeof raw === "string") {
        try {
          return JSON.parse(raw) || {};
        } catch (error) {
          console.warn("Failed to parse hourly_fixed_clock_times", error);
          return {};
        }
      }
      return {};
    },
    openClockSettingDialog() {
      if (!this.canEditClockSetting) return;
      this.clockSettingError = "";
      this.clockSettingSuccess = "";
      this.clockSettingDialogVisible = true;
      this.$nextTick(() => {
        this.clockSettingForm.clock_in_time =
          this.clockSettingInfo.clock_in_time?.slice(0, 5) || "";
        this.clockSettingForm.clock_out_time =
          this.clockSettingInfo.clock_out_time?.slice(0, 5) || "";
      });
    },
    closeClockSettingDialog() {
      this.clockSettingDialogVisible = false;
      this.clockSettingError = "";
      this.clockSettingSuccess = "";
    },
    saveClockSetting() {
      if (!this.canEditClockSetting) return;
      if (
        !this.clockSettingForm.clock_in_time ||
        !this.clockSettingForm.clock_out_time
      ) {
        this.clockSettingError = "請設定上下班時間";
        return;
      }
      this.clockSettingError = "";
      this.clockSettingInfo = {
        clock_in_time: this.clockSettingForm.clock_in_time,
        clock_out_time: this.clockSettingForm.clock_out_time,
      };
      this.closeClockSettingDialog();
    },
    startEdit() {
      this.edit = true;
      this.resetForm();
    },
    cancelEdit() {
      this.edit = false;
      this.resetForm();
    },
    submit() {
      if (this.saving) return;
      if (this.isHourlyFixedClockMissing) {
        if (this.$refs.hourlyClockCard?.scrollIntoView) {
          this.$refs.hourlyClockCard.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
        alert("約定時段必須先設定上下班時間");
        return;
      }
      if (this.isHourlyContractHoursMissing) {
        alert("約定時數需填寫每日約定工時 (大於 0)");
        return;
      }

      const normalizeDateOnly = (value) => {
        if (!value) return "";
        if (value instanceof Date && !Number.isNaN(value.getTime())) {
          return value.toISOString().slice(0, 10);
        }
        return String(value).slice(0, 10);
      };

      const originalExpectedSignDate = normalizeDateOnly(
        this.profileData.expected_sign_date,
      );
      const nextExpectedSignDate = normalizeDateOnly(this.form.expected_sign_date);
      const expectedSignDateChanged =
        originalExpectedSignDate !== nextExpectedSignDate;

      if (!this.isCreateMode && expectedSignDateChanged) {
        const confirmed = window.confirm(
          "你已變更到職日期，系統可能同步調整特休區間。儲存後請檢查特休假是否受影響，是否繼續儲存？",
        );
        if (!confirmed) {
          return;
        }
      }

      this.saving = true;
      const payload = {
        profile: {
          join_type: this.form.join_type,
          contract_work_type: this.form.contract_work_type,
          contract_salary_type: this.form.contract_salary_type,
          hourly_salary_type:
            this.form.contract_salary_type === 2
              ? this.form.hourly_salary_type
              : null,
          part_time_monthly_hours:
            this.form.contract_salary_type === 1
              ? this.form.part_time_monthly_hours
              : null,
          part_time_hourly_wage:
            this.form.contract_salary_type === 2
              ? this.form.part_time_hourly_wage
              : null,
          part_time_hourly_contract_hours:
            this.form.contract_salary_type === 2
              ? this.form.part_time_hourly_contract_hours
              : null,
          hourly_fixed_clock_times:
            this.form.contract_salary_type === 2 &&
            this.form.hourly_salary_type === 2
              ? {
                  clock_in_time: this.clockSettingInfo.clock_in_time,
                  clock_out_time: this.clockSettingInfo.clock_out_time,
                }
              : null,
          work_type: this.form.work_type,
          expected_sign_date: this.form.expected_sign_date,
          expected_resign_date: this.form.expected_resign_date || null,
          blood_type: this.form.blood_type,
          native_place: this.form.native_place,
          english_name: this.form.english_name,
          insured_unit: this.form.insured_unit,
          note: this.form.note,
        },
      };
      this.$emit("save", payload, (ok) => {
        this.saving = false;
        if (ok) this.edit = false;
      });
    },
  },
};
</script>
